import cn from "classnames";
import { Form, ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Icon } from "components/Icon";

const renderErrorContent = (error) => {
    if (typeof error !== "string") return error;
    const match = error.match(/^(.*?)\[([^\]]+)\]\(([^)]+)\)(.*)$/);
    if (!match) return error;
    const [, before, linkText, href, after] = match;
    return (
        <>
            {before}
            <Link to={href}>{linkText}</Link>
            {after}
        </>
    );
};

export const FieldTemplate = (props) => {
    const { id, children, displayLabel, rawErrors = [], rawHelp, rawDescription, classNames, uiSchema } = props;
    const helpIcon = uiSchema?.["ui:options"]?.helpIcon;
    const helpClassName = uiSchema?.["ui:options"]?.helpClassName;
    const visibleErrors = rawHelp ? rawErrors.filter((error) => error !== rawHelp) : rawErrors;
    const hasErrors = ["signature"].includes(uiSchema["ui:widget"]) ? false : visibleErrors.length > 0;

    return (
        <Form.Group className={classNames}>
            {displayLabel && rawDescription ? (
                <Form.Text className={rawErrors.length > 0 ? "text-danger" : "text-muted"}>{rawDescription}</Form.Text>
            ) : null}
            {children}
            {hasErrors && (
                <ListGroup id={`${id}-error`} as="ul" className="invalid-feedback">
                    {visibleErrors.map((error, index) => {
                        return (
                            <ListGroup.Item as="li" key={typeof error === "string" ? error : index} className="border-0 m-0 p-0">
                                <span className="m-0 text-danger">{renderErrorContent(error)}</span>
                            </ListGroup.Item>
                        );
                    })}
                </ListGroup>
            )}
            {/* TODO: add the help modal button in the same row as help text */}
            {rawHelp && (
                <Form.Text
                    className={cn(
                        rawErrors.length > 0 ? "text-danger" : "text-muted",
                        helpIcon && "d-inline-flex align-items-start gap-1 mt-2",
                        helpIcon && rawErrors.length === 0 && "opacity-70",
                        helpClassName
                    )}
                    id={`help-${id}`}
                >
                    {helpIcon && <Icon icon={["fal", "circle-info"]} className="mt-1 flex-shrink-0" />}
                    {helpIcon ? <span>{rawHelp}</span> : rawHelp}
                </Form.Text>
            )}
        </Form.Group>
    );
};
